/*
 Se agrega el keyMap del dispositivo
 */
// import BaseKeyMap from './BaseKeyMap';
import Device from '../../devices/device';
import LayersControl from '../../utils/LayersControl';
import Utils from '../../utils/Utils';
import {
  MODAL_RECORD_SERIES, 
  MODAL_CALL_CENTER, 
  MODAL_PIN } from '../../actions/modal';

const KeyInterceptor = (function() {
  let interceptors = [];
  let keyMap = null;
  let keyListener;
  const KEY_UP_EVENT = 'keyup';
  const KEY_DOWN_EVENT = 'keydown';
  const KEY_UP_PREFIX = '_UP';

  const callListeners = function(keyName, event) {
    for (let i = interceptors.length - 1; i >= 0; i--) {
      if (interceptors[i].interceptor.call(interceptors[i].callFunc, keyName, event)) {
        return true;
      }
    }
    return false;
  };

  return {
    init() {
      keyMap = null;
      interceptors = [];
      keyListener = function(e) {
        KeyInterceptor.keyPressed(e);
      };
      keyMap = Device.getDevice().getKeys();
      document.addEventListener(KEY_DOWN_EVENT, keyListener, false);
      document.addEventListener(KEY_UP_EVENT, keyListener, false);
    },
    destroy() {
      keyMap = null;
      interceptors = [];
      document.removeEventListener(KEY_DOWN_EVENT, keyListener, false);
      document.removeEventListener(KEY_UP_EVENT, keyListener, false);
    },
    getKeyMap() {
      return keyMap;
    },
    /**
     * Global key-handler function.
     * All keypresses are delegated to the registered interceptors in
     * reverse order to how they were added.  If a defaultKeyHandler was
     * passed in on the init (which it should be) this is the last registered key-handler to be run.
     *
     * @method keyPressed
     * @param {Event} e the DOM key event (passed by the container via the "onkeydown" event)
     * @return {Boolean} true if the key was handled, false if it wasn't.
     */
    keyPressed(e) {
      if (LayersControl.isUXVisible() && !Utils.isFullEpgPersistanceOpen()) {
        return;
      }
      const keyval = e.keyCode; // ? keyMap.getKey(Math.floor(keyval)) : null,i = 0;
      let keyName = KeyInterceptor.getKeyName(keyval, keyMap);
      if (keyName === 'OK') {
        const modalType = Utils.modalType();
        if(!Utils.isModalHide() && (modalType === MODAL_RECORD_SERIES || modalType === MODAL_CALL_CENTER || modalType === MODAL_PIN)){
          return;
        }
        e.stopPropagation();
        e.preventDefault();
      }
      if (e.type === KEY_UP_EVENT) {
        keyName += KEY_UP_PREFIX;
      }
      callListeners(keyName, e);
      return false;
    },
    /**
     * @method registerInterceptor
     * @param {Function} interceptorFn a function to receive the key presses
     * @param {Object} callingContext a reference back to the object containing the interceptor
     */
    registerInterceptor(interceptorFn, callingContext) {
      // console.log("registerInterceptor", "New Interceptor Added");
      interceptors.push({
        interceptor: interceptorFn,
        callFunc: callingContext
      });
    },
    /**
     * Unregisters an object for key interception events which was previously
     * @method unregisterInterceptor
     * @param {Function} interceptor
     */
    unregisterInterceptor(interceptor) {
      let i;
      for (i = 0; i < interceptors.length; i++) {
        if (interceptors[i].interceptor === interceptor) {
          interceptors.splice(i, 1);
          break;
        }
      }
    },
    /**
     * @method getKeyName
     * @param {number} key Es el key a buscar
     * @param {object} keymap Conjunto de teclas a buscarr
     * @return {string} returna el nombe de la tecla.
     */
    getKeyName(key, keymap) {
      let result = null;
      if (keymap && keymap.keys) {
        for (const k in keymap.keys) {
          if (keymap.keys[k] === key) {
            result = k;
            break;
          }
        }
        return result;
      }
      return false;
    }
  };
})();

export default KeyInterceptor;



// WEBPACK FOOTER //
// ./src/AAF/Nepg/KeyInterceptor.js